import styled from 'styled-components';
import {
	media,variables
} from 'styleUtils';

export const Container = styled.div`
  background-color: ${variables.darkGrey};
  min-height: 300px;
  padding-top: 80px;
  margin-top: 80px;
  color: ${variables.white};

  .caret:hover {
    cursor: pointer;
  }

  a {
    transition: all .3s ease;
    &:hover {
      color: ${variables.midGrey};
      transition: all .3s ease;
    }

    &.dark {
      color: ${variables.midGrey};
      &:hover {
        color: ${variables.white};
      }
    }
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  font-size: .875rem;
  flex-direction: column;
  width: 90%;
  position: relative;
  line-height: 2;

  ${media.tablet`
    width: 668px;
  `}

  ${media.smallDesktop`
    min-height: 250px;
    width: 960px;
  `}

  ${media.desktop`
    width: 1180px;
  `}

  a {
    text-decoration: none;
    transition: all .3s ease;
    padding-right: 30px;

    &:last-of-type {
      padding-right: 0;
    }
  }
`;

export const Desktop = styled.div`
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid ${variables.midGrey};
  padding-bottom: .5rem;
  min-height: 200px;
  display: none;

  ${media.smallDesktop`
    display: flex;
  `}

  .center {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: left !important;

    .center-top {
      display: flex;
      flex-direction: row;

      .footer-links {
        margin-left: 100px;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  }
`;

export const Mobile = styled.div`
  display: flex;
  flex-direction: column;

  ${media.smallDesktop`
    display: none;
  `}

  .icons {
    display: flex;
    justify-content: space-between;
  }

  .customer-service {
    padding: 2rem 0;
  }

  .section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${media.tablet`
      flex-direction: row;
      border-top: 1px solid ${variables.midGrey};
      border-bottom: 1px solid ${variables.midGrey};
    `}

    div {
      padding: 2rem 0;
    }

    &:last-of-type {
      border-top: none;
      border-bottom: solid 1px ${variables.midGrey};

      ${media.tablet`
        border-bottom: none;
      `}
    }

    &.divided {
      div {
        border-top: solid 1px ${variables.midGrey};
        ${media.tablet`
          border-top: none;
        `}
        &:last-of-type {
          border-bottom: 1px solid ${variables.midGrey};

          ${media.tablet`
            border-bottom: none;
          `}
        }
      }
    }
  }

  .dark {
    color: ${variables.midGrey};

    .mobile-copyright {
      font-size: .75rem;
      padding: 0 0 1rem;

      ${media.tablet`
        padding: 2rem;
      `}
    }
  }
`;

export const Logos = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .accreditation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 25px 0 50px;
    flex-basis: 100%;

    ${media.smallDesktop`
      flex-basis: 60%;
      justify-content: space-between;
      align-items: center;
      margin: 25px 0 50px;
    `}

    ${media.desktop`
      flex-basis: 50%;
    `}
  }

  .copyright {
    color: ${variables.midGrey};
    display: none;

    ${media.smallDesktop`
      display: initial;
    `}
  }
`;

const Logo = styled.div`
  &:hover {
    cursor: pointer;
  }

  img {
    height: 100%;
    width: 100%;
  }
`

export const LegitScript = styled(Logo)`
  width: 71.5px;
  height: 50.9px;

  ${media.tablet`
    width: 115.6px;
    height: 82.6px;
  `}
`;

export const Bbb = styled(Logo)`
  width: 137px;
  height: 28.4px;

  ${media.tablet`
    width: 230.6px;
    height: 48px;
  `}
`;

export const Hipaa = styled(Logo)`
  width: 78.2px;
  height: 45.9px;

  ${media.tablet`
    width: 130.8px;
    height: 77.1px;
  `}
`;
